import { SectionKey } from 'types';

export const isLastStep = (currentStep: SectionKey, sectionOrder: SectionKey[]) =>
  sectionOrder.indexOf(currentStep) === sectionOrder.length - 1;

export const isFirstStep = (currentStep: SectionKey, sectionOrder: SectionKey[]) =>
  sectionOrder.indexOf(currentStep) === 0;

export const getNextWizardStep = (currentStep: SectionKey, sectionOrder: SectionKey[]) => {
  const currentStepIndex = sectionOrder.indexOf(currentStep);
  return isLastStep(currentStep, sectionOrder) ? currentStep : sectionOrder[currentStepIndex + 1];
};

export const getPreviousWizardStep = (currentStep: SectionKey, sectionOrder: SectionKey[]) => {
  const currentStepIndex = sectionOrder.indexOf(currentStep);

  return isFirstStep(currentStep, sectionOrder) ? currentStep : sectionOrder[currentStepIndex - 1];
};
